import { TIME_BETWEEN_START_AND_END } from "./lib/config"
import AutoShutdown from "./AutoShutdown.vue"

export { TIME_BETWEEN_START_AND_END }

export default AutoShutdown
